import axiosPost from "../../axiosPost";
import { respuestaDe } from "../../respuesta";

export const RNHEstablecimientoGet = async (credentials, data) => {
  const body = {
    service: "RNHEstablecimientoGet",
    params: {
      rnhEstablecimientoId: data?.establecimientoId || null,
      rnhEstablecimientoCod: data?.establecimientoCod || null,
      rnhHospitalCod: data?.hospitalCod || null,
      rnhAreaCod: data?.areaCod || null,
      rnhZonaCod: data?.zonaCod || null,
      rnhNivelCod: data?.nivelCod || null,
      rnhTipoComponenteCod: data?.tipo || '',
      soloDisponibles: data?.disponibles || '',
      page: data?.page ?? null,
      pageSize: data?.pageSize ?? null,
    },
  };

  return respuestaDe(await axiosPost(body, credentials));
};